export const renderNumber = (number) => {
    if (typeof number !== 'number') return number;

    const numStr = String(number);
    const [int, dec] = numStr.split('.');

    let formatedIntStr = int;
    if (formatedIntStr.length > 3) {
        for (let i = int.length - 3; i > 0; i -= 3) {
            formatedIntStr = `${formatedIntStr.slice(0, i)},${formatedIntStr.slice(i)}`;
        }
    }

    return dec ? `${formatedIntStr}.${dec.slice(0,2)}` : formatedIntStr;
};

export const makeKey = (name) => name.replaceAll(' ', '-');